import { Controller } from "@hotwired/stimulus"

// A figure's videos together in a pop-up (dashboard/_review_wall), beside its
// new reviews in the review inbox. The players load only when it opens (each
// iframe's data-src) and are emptied when it closes, which stops them.
// They open paused: YouTube counts a view only when someone presses play.
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.closed = () => this.unload()
    this.backdrop = (e) => { if (e.target === this.dialogTarget) this.dialogTarget.close() }
    this.dialogTarget.addEventListener("close", this.closed)
    this.dialogTarget.addEventListener("click", this.backdrop)
  }

  disconnect() {
    this.dialogTarget.removeEventListener("close", this.closed)
    this.dialogTarget.removeEventListener("click", this.backdrop)
  }

  // From Watch, or from one video's link in the list (params.video): then
  // that one is scrolled to and picked out. A click meant for a new tab
  // still goes to YouTube.
  open(event) {
    const video = event?.params?.video
    if (video && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return
    event?.preventDefault()
    this.dialogTarget.querySelectorAll("iframe[data-src]").forEach((frame) => { frame.src = frame.dataset.src })
    this.dialogTarget.showModal()
    const picked = video && this.dialogTarget.querySelector(`[data-video="${CSS.escape(video)}"]`)
    this.dialogTarget.querySelectorAll(".rs-wall-card").forEach((card) => card.classList.toggle("is-picked", card === picked))
    if (picked) picked.scrollIntoView({ block: "center" })
    else this.dialogTarget.scrollTop = 0
  }

  close() {
    this.dialogTarget.close()
  }

  unload() {
    this.dialogTarget.querySelectorAll("iframe[data-src]").forEach((frame) => frame.removeAttribute("src"))
  }
}
